import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Sidenav, Nav, Dropdown } from "rsuite";
import Checkbox from "rsuite/Checkbox";
import { Button } from "../../../components";
import { getFilterCarList } from "../../../redux/cars";
import { CarLookup } from "../../../redux/cars/types/carLookup";
import { Model } from "../../../redux/cars/types/model";
import { getLocalized } from "../../../redux/localization";
import { ButtonType } from "../../../components/button";
import "./style.scss";
import { FilterObject } from "./type";
import { Car } from "../../../redux/cars/types/car";
import CustomLoader from "../../../components/loader";

const CustomCheckPicker = ({
  carlookup,
  setCars,
  setModels,
  models,
  styles,
  setPageNumber,
}: {
  setPageNumber: (i: number) => void;
  setModels: (model: Model[]) => void;
  models: Model[];
  carlookup?: CarLookup;
  setCars: (car: Car[]) => void;
  styles?: any;
}) => {
  const dispatch = useDispatch();
  const localize = useSelector(getLocalized);
  const [loader, setLoader] = useState(false);
  const filterRef = useRef<FilterObject>({
    brand: [],
    model: [],
    bodyType: [],
    gearType: [],
    fuelType: [],
  });

  return (
    <div className="custom-check-picker-div" style={styles}>
      {loader && <CustomLoader />}
      <div style={{ marginInlineEnd: 23 }} className="custom-check-picker-div">
        <div className="lat-filter" style={{ width: 300 }}>
          <Sidenav activeKey="1" className="checkPickerSideNav">
            <Sidenav.Body>
              <Nav>
                <Dropdown
                  style={{ marginBlockEnd: 20 }}
                  eventKey="1"
                  title={localize.getString("brand").toUpperCase()}
                  className="lat-filter-dropdown bold-text"
                >
                  <div className="dropdown-item-div">
                    {carlookup?.Brands.map((brand, i) => (
                      <div key={i}>
                        <Checkbox
                          defaultChecked={
                            filterRef.current.brand.some((x) => x === brand.Id)
                              ? true
                              : false
                          }
                          onChange={(value, checked, event) => {
                            if (checked) {
                              filterRef.current.brand?.push(brand.Id);
                              if (filterRef.current.brand.length <= 1) {
                                const newModels = carlookup.CarModels.filter(
                                  (x) => x.BrandName === brand.BrandName
                                );
                                setModels(newModels);
                              } else {
                                const filterArray = carlookup.CarModels.filter(
                                  (x) => x.BrandName === brand.BrandName
                                );
                                const newModels = models.concat(filterArray);
                                setModels(newModels);
                              }
                            } else {
                              filterRef.current.brand =
                                filterRef.current.brand?.filter(
                                  (x) => x !== brand.Id
                                );
                              if (filterRef.current.brand.length !== 0) {
                                const newModels = models.filter(
                                  (x) => x.BrandName !== brand.BrandName
                                );
                                setModels(newModels);
                              } else {
                                setModels(carlookup.CarModels);
                              }
                            }
                          }}
                        >
                          {brand.BrandName}
                        </Checkbox>
                      </div>
                    ))}
                  </div>
                </Dropdown>
                <p style={{ marginBlock: 5 }}></p>
                <Dropdown
                  eventKey="2"
                  title={localize.getString("model").toLocaleUpperCase()}
                  className="lat-filter-dropdown bold-text"
                >
                  <div className="dropdown-item-div">
                    {filterRef.current.brand.length <= 0
                      ? []
                      : models.map((model, i) => (
                          <div key={i}>
                            <Checkbox
                              onChange={(value, checked) => {
                                if (checked) {
                                  filterRef.current.model?.push(model.Id);
                                } else {
                                  filterRef.current.model =
                                    filterRef.current.model?.filter(
                                      (x) => x !== model.Id
                                    );
                                }
                              }}
                            >
                              {model.BrandName + " " + model.ModelName}
                            </Checkbox>
                          </div>
                        ))}
                  </div>
                </Dropdown>
                <p style={{ marginBlock: 5 }}></p>
                <Dropdown
                  eventKey="3"
                  title={localize.getString("bodytype").toLocaleUpperCase()}
                  className="lat-filter-dropdown bold-text"
                >
                  <div className="dropdown-item-div">
                    {" "}
                    {carlookup?.BodyTypes.map((body, i) => (
                      <div key={i}>
                        <Checkbox
                          onChange={(value, checked) => {
                            if (checked) {
                              filterRef.current.bodyType?.push(body.Id);
                            } else {
                              filterRef.current.bodyType =
                                filterRef.current.bodyType?.filter(
                                  (x) => x !== body.Id
                                );
                            }
                          }}
                        >
                          {body.Name}
                        </Checkbox>
                      </div>
                    ))}
                  </div>
                </Dropdown>
                <p style={{ marginBlock: 5 }}></p>
                <Dropdown
                  eventKey="4"
                  title={localize.getString("fueltype").toLocaleUpperCase()}
                  className="lat-filter-dropdown bold-text"
                >
                  <div className="dropdown-item-div">
                    {carlookup?.FuelTypes.map((fuel, i) => (
                      <div key={i}>
                        <Checkbox
                          onChange={(value, checked) => {
                            if (checked) {
                              filterRef.current.fuelType?.push(fuel.Id);
                            } else {
                              filterRef.current.fuelType =
                                filterRef.current.fuelType?.filter(
                                  (x) => x !== fuel.Id
                                );
                            }
                          }}
                        >
                          {fuel.Name}
                        </Checkbox>
                      </div>
                    ))}
                  </div>
                </Dropdown>
                <p style={{ marginBlock: 5 }}></p>
                <Dropdown
                  eventKey="5"
                  title={localize.getString("geartype").toLocaleUpperCase()}
                  className="lat-filter-dropdown bold-text"
                >
                  <div className="dropdown-item-div">
                    {carlookup?.GearTypes.map((gear, i) => (
                      <div key={i}>
                        <Checkbox
                          onChange={(value, checked) => {
                            if (checked) {
                              filterRef.current.gearType?.push(gear.Id);
                            } else {
                              filterRef.current.gearType =
                                filterRef.current.gearType?.filter(
                                  (x) => x !== gear.Id
                                );
                            }
                          }}
                        >
                          {gear.Name}
                        </Checkbox>
                      </div>
                    ))}
                  </div>
                </Dropdown>
              </Nav>
            </Sidenav.Body>
          </Sidenav>
        </div>
        <div className="w-100 d-flex justify-content-center">
          <Button
            style={{
              width: "150px",
              marginBlock: 10,
              marginInlineEnd: 20,
              fontSize: 24,
              fontWeight: 700,
            }}
            buttonType={ButtonType.newColored}
            title={localize.getString("filter")}
            onClick={() => {
              const _brand =
                filterRef.current.brand.length === 0
                  ? undefined
                  : filterRef.current.brand;

              const _model =
                filterRef.current.model.length === 0
                  ? undefined
                  : filterRef.current.model;
              const _bodyType =
                filterRef.current.bodyType.length === 0
                  ? undefined
                  : filterRef.current.bodyType;
              const _fuelType =
                filterRef.current.fuelType.length === 0
                  ? undefined
                  : filterRef.current.fuelType;
              const _gearType =
                filterRef.current.gearType.length === 0
                  ? undefined
                  : filterRef.current.gearType;

              let path = `?brand=${_brand}&model=${_model}&bodyType=${_bodyType}&gearType=${_gearType}&fuelType=${_fuelType}`;

              setLoader(true);
              dispatch(
                getFilterCarList({
                  payload: {
                    onSuccess: (message, payload) => {
                      setPageNumber(1);
                      setCars(payload);
                      setLoader(false);
                    },
                    onError: (message) => {},
                  },
                  url: "api/car/filter" + path,
                })
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};
export default CustomCheckPicker;
